import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $GraftX = (_1, _2, _3) => ({tag: "Graft", _1, _2, _3});
const $VDom = (tag, _1, _2, _3, _4) => ({tag, _1, _2, _3, _4});
const identity = x => x;
const Namespace = x => x;
const ElemName = x => x;
const Text = value0 => $VDom("Text", value0);
const Elem = value0 => value1 => value2 => value3 => $VDom("Elem", value0, value1, value2, value3);
const Keyed = value0 => value1 => value2 => value3 => $VDom("Keyed", value0, value1, value2, value3);
const Widget = value0 => $VDom("Widget", value0);
const Grafted = value0 => $VDom("Grafted", value0);
const Graft = value0 => value1 => value2 => $GraftX(value0, value1, value2);
const unGraft = f => x => f(x);
const ordNamespace = Data$dOrd.ordString;
const ordElemName = Data$dOrd.ordString;
const newtypeNamespace = {Coercible0: () => {}};
const newtypeElemName = {Coercible0: () => {}};
const graft = Unsafe$dCoerce.unsafeCoerce;
const functorGraft = {map: g => x => $GraftX(x._1, x$1 => g(x._2(x$1)), x._3)};
const functorVDom = {
  map: v => v1 => {
    if (v1.tag === "Text") { return $VDom("Text", v1._1); }
    if (v1.tag === "Grafted") {
      const $0 = v1._1;
      return $VDom("Grafted", $GraftX($0._1, x => v($0._2(x)), $0._3));
    }
    return $VDom("Grafted", $GraftX(identity, v, v1));
  }
};
const eqNamespace = Data$dEq.eqString;
const eqElemName = Data$dEq.eqString;
const bifunctorGraft = {bimap: f => g => x => $GraftX(x$1 => f(x._1(x$1)), x$1 => g(x._2(x$1)), x._3)};
const bifunctorVDom = {
  bimap: v => v1 => v2 => {
    if (v2.tag === "Text") { return $VDom("Text", v2._1); }
    if (v2.tag === "Grafted") {
      const $0 = v2._1;
      return $VDom("Grafted", $GraftX(x => v($0._1(x)), x => v1($0._2(x)), $0._3));
    }
    return $VDom("Grafted", $GraftX(v, v1, v2));
  }
};
const runGraft = x => {
  const go = v2 => {
    if (v2.tag === "Text") { return $VDom("Text", v2._1); }
    if (v2.tag === "Elem") { return $VDom("Elem", v2._1, v2._2, x._1(v2._3), Data$dFunctor.arrayMap(go)(v2._4)); }
    if (v2.tag === "Keyed") { return $VDom("Keyed", v2._1, v2._2, x._1(v2._3), Data$dFunctor.arrayMap(m => Data$dTuple.$Tuple(m._1, go(m._2)))(v2._4)); }
    if (v2.tag === "Widget") { return $VDom("Widget", x._2(v2._1)); }
    if (v2.tag === "Grafted") {
      const $0 = v2._1;
      return $VDom("Grafted", $GraftX(x$1 => x._1($0._1(x$1)), x$1 => x._2($0._2(x$1)), $0._3));
    }
    $runtime.fail();
  };
  return go(x._3);
};
const renderWidget = f => g => v => {
  if (v.tag === "Text") { return $VDom("Text", v._1); }
  if (v.tag === "Elem") { return $VDom("Elem", v._1, v._2, f(v._3), Data$dFunctor.arrayMap(renderWidget(f)(g))(v._4)); }
  if (v.tag === "Keyed") {
    return $VDom(
      "Keyed",
      v._1,
      v._2,
      f(v._3),
      Data$dFunctor.arrayMap((() => {
        const $0 = renderWidget(f)(g);
        return m => Data$dTuple.$Tuple(m._1, $0(m._2));
      })())(v._4)
    );
  }
  if (v.tag === "Widget") { return g(v._1); }
  if (v.tag === "Grafted") { return renderWidget(f)(g)(runGraft(v._1)); }
  $runtime.fail();
};
export {
  $GraftX,
  $VDom,
  Elem,
  ElemName,
  Graft,
  Grafted,
  Keyed,
  Namespace,
  Text,
  Widget,
  bifunctorGraft,
  bifunctorVDom,
  eqElemName,
  eqNamespace,
  functorGraft,
  functorVDom,
  graft,
  identity,
  newtypeElemName,
  newtypeNamespace,
  ordElemName,
  ordNamespace,
  renderWidget,
  runGraft,
  unGraft
};
